export default __webpack_public_path__ + "static/media/portfolio-2.30345861.jpg";